export default {"src":"/_next/static/media/install.1be6948c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};